import { createContext } from "react";

import { useRequiredContext } from "~/tools/use-required-context";

import type { ToggleListState } from "./ToggleListState";

const ToggleListStateContext = createContext<null | ToggleListState>(null);

export const ToggleListStateContextProvider = ToggleListStateContext.Provider;

export const useToggleListState = (): ToggleListState =>
	useRequiredContext(ToggleListStateContext, {
		providerName: "ToggleListStateProvider",
	});
